import React from 'react';
import { EMAIL } from '@/constants';
import TextXl from '../Typography/TextXl';
import TextSmall from '../Typography/TextSmall';

function RenderHeader({ title, subTitle, subTitle2 = '' }) {
  return (
    <div className="flex flex-col gap-[16px] items-center mb-32">
      <TextXl
        text={title}
        className="text-xl lg:text-xl font-semibold text-fire-chalk"
      />
      <div className="flex flex-col items-center">
        <TextSmall className="text-sm lg:text-sm text-center font-medium">
          {subTitle}
          {subTitle2.length ? (
            <>
              <br /> <span>{subTitle2}</span>
            </>
          ) : null}
        </TextSmall>
      </div>
    </div>
  );
}

function MyProfileHeader({ type = 'default', activeTab = EMAIL, userInfo }) {
  if (type === 'default') {
    return (
      <div className="w-full flex flex-col gap-[12px]">
        <TextXl
          text="Account Details"
          className="text-lg lg:text-xl font-semibold"
        />
        <TextSmall
          text="Your registered phone number and email for logging into your singer
          account"
          className="text-sm lg:text-sm font-normal"
        />
      </div>
    );
  }
  if (type === 'update-profile') {
    return (
      <RenderHeader
        title={`Add ${activeTab === EMAIL ? ' Email Address' : ' Phone Number'}`}
        subTitle={`Your ${activeTab === EMAIL ? ' Email Address' : ' Phone Number'} will
            be verified`}
        subTitle2="through a 6 digit OTP code"
      />
    );
  }
  if (type === 'otpForm') {
    return (
      <RenderHeader
        title="OTP Verification"
        subTitle={`Your 6 digit code has been sent
            ${activeTab === EMAIL ? ' via email' : ' '} to`}
        subTitle2={`${activeTab === EMAIL ? '' : ' +880'}${userInfo}`}
      />
    );
  }
}

export default MyProfileHeader;
